// /src/context/RuntimeValuesContext.tsx
import React, {createContext, useState, Dispatch, SetStateAction, ReactNode} from 'react';

interface Cart {
    productId: number | null;
    name: string | null;
    image: string | null;
    fallbackImage: string | null;
    price: number | null;
    cant: number | null;
}

export type RuntimeValues = {
    currency: string
    currencySymbol: string
    country: string
    countryCode: string
    language: string
    cart: Cart[]
    clientName: string
    clientEmail: string
    shipping: string
    shippingAddressStreet: "",
    shippingAddressCompl: "",
    shippingCity: "",
    shippingState: "",
    shippingZipCode: "",
    shippingPhoneNumber: "",
    shippingPrice: 0,
    shippingETA: string,
    payment: string
}

export interface RuntimeValuesContextInterface{
    runtimeValues: RuntimeValues,
    setRuntimeValues: Dispatch<SetStateAction<RuntimeValues>>
}

const defaultState = {
    runtimeValues: {
        currency: 'USD',
        currencySymbol: '$',
        country: 'USA',
        countryCode: 'US',
        language: 'ENGLISH',
        cart: [],
        clientName: "",
        clientEmail: "",
        shipping: "pickup",
        shippingAddressStreet: "",
        shippingAddressCompl: "",
        shippingCity: "",
        shippingState: "",
        shippingZipCode: "",
        shippingPhoneNumber: "",        
        shippingPrice: 0,
        shippingETA: "",
        payment: "creditCard"
    },
    setRuntimeValues: (runtimeValues: RuntimeValues) => {}
} as RuntimeValuesContextInterface

export const RuntimeValuesContext = createContext(defaultState)

type RuntimeValuesProviderProps = {
    children: ReactNode
}

export default function RuntimeValuesProvider({children} : RuntimeValuesProviderProps){
    const [runtimeValues, setRuntimeValues] = useState<RuntimeValues>({
        currency: 'USD',
        currencySymbol: '$',
        country: 'USA',
        countryCode: 'US',
        language: 'ENGLISH',
        cart: [],
        clientName: "",
        clientEmail: "",
        shipping: "pickup",
        shippingAddressStreet: "",
        shippingAddressCompl: "",
        shippingCity: "",
        shippingState: "",
        shippingZipCode: "",
        shippingPhoneNumber: "",
        shippingPrice: 0,
        shippingETA: "",
        payment: "creditCard"
    });

    return (
        <RuntimeValuesContext.Provider value={{runtimeValues, setRuntimeValues}}>
            {children}
        </RuntimeValuesContext.Provider>
    );
}